import { render, staticRenderFns } from "./menu_tree_bf.vue?vue&type=template&id=d462ab92&scoped=true&"
import script from "./menu_tree_bf.vue?vue&type=script&lang=js&"
export * from "./menu_tree_bf.vue?vue&type=script&lang=js&"
import style0 from "./menu_tree_bf.vue?vue&type=style&index=0&id=d462ab92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d462ab92",
  null
  
)

export default component.exports